import React from "react"
import { CardListModule } from "../../carlsberg-headless/types/modules/CardList"
import { IterableModule } from "../../carlsberg-headless/types/modules/util/module"
import { getReactCMSComponent } from "../../carlsberg-headless/getReactCMSComponent"
import { FlexRow, FlexCell } from "@shared-components/FlexGrid/FlexGrid"
import { Container } from "@shared-components/Container/Container"
import { layoutProps, ListLayout } from "@styles/utils/getLayout"
import { THEMES_MAP } from "../../carlsberg-headless/themes-map"
import { TextCardContentElement } from "../../carlsberg-headless/types/content-elements/TextCard"
import { ImageCardContentElement } from "../../carlsberg-headless/types/content-elements/ImageCard"
import { VideoCardContentElement } from "../../carlsberg-headless/types/content-elements/VideoCard"
import { Nullable } from "../../shared/types/util"

const spacing = [2, 2, 3]

export type CardListProps = CardListModule
interface CardRepeatProps {
  taxonomi: layoutProps[]
  themes: string[]
  cards: Nullable<
    | TextCardContentElement[]
    | ImageCardContentElement[]
    | VideoCardContentElement[]
  >
  cbKey: string
  spacing: number[]
}
const CardRepeater = ({
  taxonomi,
  cards,
  cbKey,
  spacing,
  themes,
}: CardRepeatProps) => {
  const noSpacing = themes.includes(
    THEMES_MAP.cards_module.cards_module_nospacing
  )

  let rowIndex = 0 as number
  const rows = []

  let cellIndex = 0 as number
  let cells = []

  let cardIndex = 0 as number

  while (cards && cards.length) {
    const row = taxonomi[rowIndex]
    const cell = row.children && row.children[cellIndex]
    const card = cards.shift()
    if (!card) {
      break
    }

    if (cell) {
      card["ratio"] = cell.ratio
      cells.push(
        <FlexCell
          key={`children_cell_${cbKey}_${rowIndex}_${cellIndex}_${cardIndex}`}
          col={cell.col}
          {...(noSpacing &&
            card.themes.length === 0 && { sx: { p: [4, 0, 0] } })}
        >
          {getReactCMSComponent({
            alias: card.alias,
            props: { ...card },
          })}
        </FlexCell>
      )

      cellIndex++

      if ((row && !row.children[cellIndex]) || cards.length === 0) {
        rows.push(
          <FlexCell
            key={`cell_${cbKey}_${rowIndex}_${cardIndex}_${cardIndex}`}
            col={row.col}
          >
            <FlexRow spacing={spacing}>{cells}</FlexRow>
          </FlexCell>
        )

        cells = []
        cellIndex = 0
        rowIndex++
      }
    } else {
      card["ratio"] = row.ratio
      rows.push(
        <FlexCell
          key={`cell_${cbKey}_${rowIndex}_${cardIndex}`}
          col={row.col}
          {...(noSpacing &&
            card.themes.length === 0 && { sx: { p: [4, 0, 0] } })}
        >
          {getReactCMSComponent({
            alias: card.alias,
            props: { ...card },
          })}
        </FlexCell>
      )
      rowIndex++
    }

    if (!taxonomi[rowIndex]) {
      rowIndex = 0
    }

    cardIndex++
  }

  return rows
}

const CardList: React.FC<CardListProps> = ({
  taxonomies,
  themes,
  cards,
  cbKey,
}) => {
  if (!cards) {
    return null
  }

  const listLayout = new ListLayout(taxonomies, "hc_list_layout_2")

  if (!listLayout.taxonomi) {
    return (
      <Container key={cbKey}>
        {(cards as unknown as IterableModule[]).map(({ alias, ...props }) =>
          getReactCMSComponent({
            alias,
            props,
          })
        )}
      </Container>
    )
  } else {
    return (
      <Container key={cbKey} sx={{ px: 0 }}>
        <FlexRow spacing={spacing}>
          {CardRepeater({
            taxonomi: listLayout.taxonomi,
            cards: [...cards],
            cbKey: cbKey,
            spacing: spacing,
            themes: themes,
          })}
        </FlexRow>
      </Container>
    )
  }
}

export { CardList }
